export default __webpack_public_path__ + "static/media/marketplace-info-hero-1.3a0cef09.jpg";